<div [ngClass]="{'darkMode': darkMode}">
    <div class="batchEditSection">
        <label>Add Images to &nbsp;</label>
        <div class="btn-group btn-group-sm btn-group-toggle" data-bs-toggle="buttons">
            <label class="btn btn-sm btn-light" [ngClass]="{'active': setMode === 0, 'inactive': setMode !== 0, 'btn-dark': darkMode}" (click)="changeSetMode(0)">No Set</label>
            <label class="btn btn-sm btn-light" [ngClass]="{'active': setMode === 1, 'inactive': setMode !== 1, 'btn-dark': darkMode}" (click)="changeSetMode(1)">Related Set</label>
            <label class="btn btn-sm btn-light" [ngClass]="{'active': setMode === 2, 'inactive': setMode !== 2, 'btn-dark': darkMode}" (click)="changeSetMode(2)">Bound Set</label>
        </div>
        <form>
            <div *ngIf="setMode === 1">
                <div class="row" [ngClass]="{'edited': record.isRelatedSet}" style="justify-content: center;">
                    <div class="column mtbauto leftColumn">
                        Related Set Name:
                    </div>
                    <div class="column mtbauto">
                        <mat-form-field>
                            <input type="text" class="form-control" aria-label="relatedSetName" matInput [formControl]="relatedSetControl" [matAutocomplete]="relatedSets">
                            <mat-autocomplete #relatedSets="matAutocomplete">
                                <mat-option *ngFor="let set of filteredRelatedSets" [value]="set.name" [matTooltip]="set.name" [matTooltipPosition]="'left'">
                                    {{ set.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div *ngIf="setMode === 2">
                <div class="row" [ngClass]="{'edited': record.isBoundSet}" style="justify-content: center;">
                    <div class="column mtbauto leftColumn">
                        Bound Set Name:
                    </div>
                    <div class="column mtbauto">
                        <mat-form-field>
                            <input type="text" class="form-control" aria-label="boundSetName" matInput [formControl]="boundSetControl" [matAutocomplete]="autoBoundSets">
                            <mat-autocomplete #autoBoundSets="matAutocomplete">
                                <mat-option *ngFor="let set of filteredBoundSets" [value]="set.name" [matTooltip]="set.name" [matTooltipPosition]="'left'">
                                    {{ set.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="batchEditSection" [ngClass]="{'edited': checkedOutEdited()}">
        <div class="row">
            <div class="column mtbauto leftColumn">
                Checked Out: 
            </div>
            <div class="column mtbauto" style="text-align: left;">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="checkedOutCheckbox" 
                           [(ngModel)]="record.checkedOut">
                    <label class="form-check-label" for="checkedOutCheckbox">
                        <!-- Optional label text if needed -->
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="batchEditSection">
        <div class="row" [ngClass]="{'edited': locationEdited()}">
            <div class="column mtbauto leftColumn">
                Location:
            </div>
            <div class="column mtbauto">
                <mat-form-field>
                    <input type="text" class="form-control" aria-label="Location" matInput [formControl]="locationControl" [matAutocomplete]="autoLocations">
                    <mat-autocomplete #autoLocations="matAutocomplete">
                        <mat-option *ngFor="let location of filteredLocations" [value]="location">
                        {{ location }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="batchEditSection">
        <div class="row" [ngClass]="{'edited': stateEdited()}">
            <div class="column mtbauto leftColumn">
                State:
            </div>
            <div class="column mtbauto">
              <select name="locationState" class="form-control" id="locationState"
                (change)="changeLocationState($event.target.value)" [(ngModel)]="record.locationStateID">
                <option [ngValue]="">No state chosen</option>
                <option *ngFor="let s of states" [value]="s.uid">{{ s.state_Name }}</option>
              </select>
            </div>
        </div>
    </div>
    <div class="batchEditSection" [ngClass]="{'edited': armyEdited()}">
        <div class="row">
            <div class="column mtbauto leftColumn">
                Army:
            </div>
            <div class="column">
                <select name="army" class="form-control" id="army"
                  (change)="changeArmy($event.target.value)" [(ngModel)]="record.armyId">
                    <option value="null">No Army Chosen</option>
                    <option *ngFor="let a of armies" [value]="a.uid">{{ a.army?.armyName }} &ndash; {{ a.regionalName }}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="batchEditSection" [ngClass]="{'edited': notesEdited()}">
        <div class="row">
            <div class="column mtbauto leftColumn">
                Notes: 
            </div>
            <div class="column mtbauto">
                <textarea type="text" placeholder="Notes" class="editable form-control" id="notes" name="notes"
                    [(ngModel)]="record.notes"></textarea>
            </div>
        </div>
    </div>
    <div class="batchEditSection" [ngClass]="{'edited': keywordsEdited(true)}">
        <div class="align-items-baseline keywords">
            <app-keywords-display *ngIf="addKeywordsDisplay" [data]="record.addKeywords"
                (deleteMeEmitter)="removeKeyword($event, true)" [isAdmin]="true">
            </app-keywords-display>
            <div class="row keywords-input-row">
              <div class="col-6" style="text-align: end;">
                <label for="keywordInput" class="keywords-label">Add keywords:</label>
              </div>
              <div class="col-6">
                <app-keyword-search dropDown="true" [selectionMode]="true" allDataDropdown="true" (selectedOutput)="addKeyword($event, true)" (errorOutput)="keywordSearchError($event)"></app-keyword-search>
              </div>
            </div>
        </div>
    </div>
    <div class="batchEditSection" [ngClass]="{'edited': keywordsEdited(false)}">
        <div class="align-items-baseline keywords">
            <app-keywords-display *ngIf="removeKeywordsDisplay" [data]="record.removeKeywords"
                (deleteMeEmitter)="removeKeyword($event, false)" [isAdmin]="true">
            </app-keywords-display>
            <div class="row keywords-input-row">
              <div class="col-6" style="text-align: end;">
                <label for="keywordInput" class="keywords-label">Remove keywords:</label>
              </div>
              <div class="col-6">
                <app-keyword-search dropDown="true" [selectionMode]="true" allDataDropdown="true" (selectedOutput)="addKeyword($event, false)" (errorOutput)="keywordSearchError($event)"></app-keyword-search>
              </div>
            </div>
        </div>
    </div>
    <div class="batchEditSection" [ngClass]="{'edited': battlesEdited()}">
        <div class="row">
          <h3 style="font-size: 1rem; color: #777;">
            {{this.imageType.uid !== ImageTypes['Letters & Diaries'] ? 'Battle:' : 'Battles:'}}
          </h3>
        </div>
        <div class="row">
          <div style='width:50%; height: 35px; margin-bottom: 15px; display: block;'>
             <app-battle-search #battleSearch configIcon="fa-ellipsis-v" maxResults="10" (selectedOutput)="addBattle($event)" allDataDropdown="true" dropDown="true" (errorOutput)="battleSearchError($event)"></app-battle-search>
          </div>
        </div>
        <div class="parent" *ngIf="record?.addBattles.length">
            <div class="grid">
              <span class="columnHeader"></span>
            </div>
            <div class="grid gridRow" *ngFor="let b of record.addBattles">
              <span class="pertinent">{{ b?.name }}<i (click)="removeBattle(b)" class="fas fa-trash ms-1" title="Remove entry" style="cursor: pointer; margin: 0.25em;"></i></span>
            </div>         
        </div>
    </div>
    <div class="batchEditSection" [ngClass]="{'edited': datesEdited()}">
        Dates:
        <div class="row">
            <table>
                <thead>
                    <tr>
                        <th>Month</th>
                        <th>Day</th>
                        <th>Year</th>
                        <th>
                            <app-slant-button btnColor="gray" btnIconClass="fa-plus" [ngClass]="{'darkMode': darkMode}" (click)="addDate()">Add Date</app-slant-button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let date of record.addDates">
                        <td>
                            <select class="form-control" [(ngModel)]="date.month">
                                <option *ngFor="let m of Months" [value]="m.val">{{ m.txt }}</option>
                            </select>
                        </td>
                        <td>
                            <input class="form-control" type="number" min="0" max="31" [(ngModel)]="date.day" (keyup)="enforceDayMinMax(date)">
                        </td>
                        <td>
                            <input class="form-control" type="number" min="1" max="3000" [(ngModel)]="date.year" (keyup)="enforceYearMinMax(date)">
                        </td>
                        <td>
                            <app-slant-button btnColor="gray" btnIconClass="fa-trash" [ngClass]="{'darkMode': darkMode}" (click)="removeDate(date)"></app-slant-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="batchEditSection" [ngClass]="{'edited': unitsEdited()}">
        Units:
        <div class="row">
          <app-unit-picker *ngIf="showUnitBuilder" [coLetters]="companyLetters" [regiments]="regiments"
            [states]="states" [branches]="branches" (unitSelected)="addUnit($event)">
          </app-unit-picker>
          <br>
          <table>
            <thead>
                <tr>
                    <th>Army</th>
                    <th>Corps</th>
                    <th>Regiment</th>
                    <th>State</th>
                    <th>Branch</th>
                    <th>Co. Letters</th>
                    <th><app-slant-button btnColor="gray" class="new-unit-btn" (click)="showUnitBuilder = !showUnitBuilder" [btnIconClass]="showUnitBuilder ? 'fa-times' : 'fa-plus'">{{ showUnitBuilder ? 'Cancel' : 'Add Unit' }}</app-slant-button></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let unit of record.addUnits">
                    <td>{{ unit.army }}</td>
                    <td>{{ unit.corps }}</td>
                    <td>{{ writeOrdinalSuffix(unit.regimentNo?.regimentNo) }}</td>
                    <td>{{ unit.state?.abbreviation }}</td>
                    <td>{{ unit.branch?.branchName }}</td>
                    <td>{{ unit.companyLetters }}</td>
                    <td><app-slant-button btnColor="gray" btnIconClass="fa-trash" [ngClass]="{'darkMode': darkMode}" (click)="removeUnit(unit)"></app-slant-button></td>
                </tr>
            </tbody>
          </table>
        </div>
    </div>
    <div class="batchEditSection" [ngClass]="{'edited': weaponsEdited()}">
        Weapons:
        <div class="row">
            <table>
                <thead>
                    <tr>
                        <th>Weapon Category</th>
                        <th>Weapon</th>
                        <th>
                            <app-slant-button btnColor="gray" btnIconClass="fa-plus" [ngClass]="{'darkMode': darkMode}" (click)="addWeapon()">Add Weapon</app-slant-button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let weapon of record.addWeapons">
                        <td>
                            <select class="form-control" (change)="setWeaponCategory($event.target.value, weapon)">
                                <option [value]="undefined"></option>
                                <option *ngFor="let w of weaponCategories" [value]="w.uid">{{ w.weapon_Category }}</option>
                            </select>
                        </td>
                        <td>
                            <select class="form-control" [(ngModel)]="weapon.weaponModelId">
                                <option [value]="undefined"></option>
                                <option *ngFor="let w of filteredWeapons(weapon)" [value]="w.uid" (click)="weapon.weapon = w;">{{ w.secondaryWeapon }}</option>
                            </select>
                        </td>
                        <td>
                            <app-slant-button btnColor="gray" btnIconClass="fa-trash" [ngClass]="{'darkMode': darkMode}" (click)="removeWeapon(weapon)"></app-slant-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="batchEditSection" [ngClass]="{'edited': qmEdited()}">
        Contract Items
        <div class="row">
          <div style="width:350px; height: 35px; margin-bottom: 15px; display: block;">
             <app-qm-search #qmManualSearch configIcon="fa-ellipsis-v" maxResults="5" (selectedOutput)="addQm($event)" allDataDropdown="true" dropDown="true" (errorOutput)="qmSearchError($event)"></app-qm-search>
          </div>
        </div>
        <div class="row">
          <app-qmmanuals-display
          [columns]="['Item Name']" (removeAction)='removeQm($event)' [data]="mapQMLinkArray()" [isAdmin]="true" [editable]="true">
          </app-qmmanuals-display>
        </div>
    </div>
    <div *ngIf="!imageType || imageType?.uid !== ImageTypes.Ordnance_Returns" class="batchEditSection" [ngClass]="{'edited': individualsEdited()}">
        Individuals
        <app-slant-button class="new-unit-btn" btnColor="gray" (click)="addImageIndividual()" btnIconClass="fa-plus">Add</app-slant-button>
        <div style="width: 100%; height: 100%;" class="individualUploadMode">
            <app-individuals-entry *ngIf="showIndividualEditor" [dropdownTypeDebounceTime]="appGlobalsSvc.dropdownTypeDebounceTime"
                [typeOfImageId]="imageType?.uid" [showIndividual]="showIndividualEditor" [data]="individualData"
                [editMode]="individualEditMode" [rankCats]="rankCats" [regiments]="regiments"
                [states]="states" [branches]="branches" [coLetters]="companyLetters"
                (doneAdding)="doneAddingIndividual($event)" (cancel)="cancelIndividualChanges()"
                (doneEditing)="doneEditingIndividual($event)" (delete)="commitImageIndividualRemoval($event)">
            </app-individuals-entry>
        </div>
        <div class="individualContainer">
            <app-individuals-display
              [typeOfImageId]="imageType?.uid"
              [columns]="['Name','Rank', (imageType?.uid === ImageTypes['Letters & Diaries']) ? 'Author' : 'Rank in Photo', 'Regiment','State','Branch','Company','Notes']" [isAdmin]="true"
              [data]="record.addIndividuals" [totalRecords]="record.addIndividuals.length" [editable]=true (editRow)="editIndividual($event)">
            </app-individuals-display>
        </div>
    </div>
    <hr>
    <div class="batchEditSection" style="text-align: end;">
        <app-slant-button class="new-unit-btn me-1" btnColor="green" (click)="confirmBatchEdit()" btnIconClass="fa-check">Confirm</app-slant-button>
        <app-slant-button class="new-unit-btn" btnColor="yellow" (click)="closeBatchEdit()" btnIconClass="fa-times">Close</app-slant-button>
    </div>
</div>
